/**
 * Set the current sort
 *
 * Will trigger new search
 *
 * @param sortField String
 * @param sortDirection String ["asc"|"desc"]
 */
export default function setSort(sortField, sortDirection) {
  var _console; // eslint-disable-next-line no-console


  if (this.debug) (_console = console).log.apply(_console, ["Search UI: Action", "setSort"].concat(Array.prototype.slice.call(arguments)));

  this._updateSearchResults({
    current: 1,
    sortDirection: sortDirection,
    sortField: sortField
  });
}